<template>
  <div class="playerList">
    <!-- 页头 -->
    <div class="page-header-style">
      <el-page-header @back="goBack" :content="$t('lang.title_playerList')"></el-page-header>
    </div>
    <!-- 筛选 -->
    <div class="filters">
      <el-form :inline="true" label-suffix=":">
        <!-- 性别select -->
        <el-form-item :label="$t('lang.lab_gender')">
          <el-select v-model="gender" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_gender')">
            <el-option
              v-for="(item,index) in genders"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 状态select -->
        <el-form-item :label="$t('lang.lab_enrollStatus')">
          <el-select v-model="state" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_enrollStatus')">
            <el-option
              v-for="(item,index) in states"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 姓名input -->
        <el-form-item :label="$t('lang.lab_name')">
          <input style="display: none"/>
          <el-input v-model="name" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_name')"></el-input>
        </el-form-item>
        <!-- 证件号input -->
        <el-form-item :label="$t('lang.lab_certificateNum')">
          <input style="display: none"/>
          <el-input v-model="certificateNum" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_certificateNum')"></el-input>
        </el-form-item>
        <!-- 查询 -->
        <el-button type="primary" @click="onSearch(true,true)">{{$t('lang.btn_search')}}</el-button>
        <!-- 重置 -->
        <el-button type="primary" @click="onClear">{{$t('lang.btn_reset')}}</el-button>
      </el-form>
    </div>
    <!-- 表格 -->
    <el-card>
      <!-- 按钮 -->
      <el-upload
        ref="uploading"
        slot="header"
        action
        :on-remove="handleRemove"
        :on-change="handleSuccess"
        :on-exceed="outlimit"
        :on-error="uploadErr"
        :limit="1"
        accept=".xlsx"
        :file-list="fileList"
        :auto-upload="false">
        <!-- 选择文件 -->
        <el-button slot="trigger" size="primary" type="primary">{{$t('lang.btn_selectExcel')}}</el-button>
        <!-- 成绩导入 -->
        <el-button style="margin-right: 10px;" size="primary" type="success" @click="onImport">{{$t('lang.btn_importData')}}</el-button>
        <!-- 数据导出 -->
        <el-button style="margin-left: 10px;" size="primary" type="primary" @click="onExport">{{$t('lang.btn_exportData')}}</el-button>
        <!-- 批量通过 -->
        <el-button style="margin-left: 10px;" size="primary" type="primary" @click="onPass">{{$t('lang.btn_batchPass')}}</el-button>
      </el-upload>
      <el-table
        class="wid100"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        @sort-change="changeTableSort"
      >
        <!-- 复选框 -->
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <!-- 名次 -->
        <el-table-column prop="ranking" :label="$t('lang.lab_ranking')" width="70px">
          <template slot-scope="scope">
            <span>{{ scope.row.ranking | valueIsNull}}</span>
          </template>          
        </el-table-column>
        <!-- 编号 -->
        <el-table-column prop="competeOrder" :label="$t('lang.lab_competeOrder')" width="70px">
          <template slot-scope="scope">
            <span>{{ scope.row.competeOrder | valueIsNull}}</span>
          </template>          
        </el-table-column>
        <!-- 姓名 -->
        <el-table-column prop="name" :label="$t('lang.lab_name')" :sortable="'custom'" width="120px"></el-table-column>
        <!-- 性别 -->
        <el-table-column prop="gender" :label="$t('lang.lab_gender')" :sortable="'custom'">
        </el-table-column>
        <!-- 年龄 -->
        <el-table-column prop="age" :label="$t('lang.lab_age')" :sortable="'custom'"></el-table-column>
        <!-- 状态 -->
        <el-table-column prop="reviewStatus" :label="$t('lang.lab_enrollStatus')" :sortable="'custom'">
          <template slot-scope="scope">
            <!-- 0: 已取消 -->
            <span v-if="scope.row.enrollStatus === 0">{{$t('lang.Player_enrollStatus[1].name')}}</span>
            <!-- 1: 已报名 -->
            <span v-if="scope.row.enrollStatus === 1 && scope.row.reviewStatus === 0">{{$t('lang.Player_enrollStatus[2].name')}}</span>
            <!-- 2: 待审核 -->
            <span v-if="scope.row.enrollStatus === 1 && scope.row.reviewStatus === 1">{{$t('lang.Player_enrollStatus[3].name')}}</span>
            <!-- 3: 审核通过 -->
            <span v-if="scope.row.enrollStatus === 1 && scope.row.reviewStatus === 2">{{$t('lang.Player_enrollStatus[4].name')}}</span>
            <!-- 4: 审核未通过 -->
            <span v-if="scope.row.enrollStatus === 1 && scope.row.reviewStatus === 3">{{$t('lang.Player_enrollStatus[5].name')}}</span>
          </template>
        </el-table-column>
        <!-- 证件类型 -->
        <el-table-column prop="idType" :label="$t('lang.lab_certificateType')" :sortable="'custom'" width="100px">
          <template slot-scope="scope">
            <span>{{scope.row.idType.replace(new RegExp('0','g'),$t('lang.MeetingRecordDetail_idType[0].name')).replace(new RegExp('1','g'),$t('lang.MeetingRecordDetail_idType[1].name')).replace(new RegExp('2','g'),$t('lang.MeetingRecordDetail_idType[2].name')).replace(new RegExp('3','g'),$t('lang.MeetingRecordDetail_idType[3].name'))}}</span>
            <!-- 0: 身份证 -->
            <!-- <span v-if="scope.row.idType === '0'">{{$t('lang.MeetingRecordDetail_idType[0].name')}}</span> -->
            <!-- 1: 护照 -->
            <!-- <span v-if="scope.row.idType === '1'">{{$t('lang.MeetingRecordDetail_idType[1].name')}}</span> -->
            <!-- 2: 港澳身份证 -->
            <!-- <span v-if="scope.row.idType === '2'">{{$t('lang.MeetingRecordDetail_idType[2].name')}}</span> -->
            <!-- 3: 台胞证 -->
            <!-- <span v-if="scope.row.idType === '3'">{{$t('lang.MeetingRecordDetail_idType[3].name')}}</span> -->
          </template>
        </el-table-column>
        <!-- 证件号 -->
        <el-table-column prop="idCard" :label="$t('lang.lab_certificateNum')" :sortable="'custom'" width="180px"></el-table-column>
        <!-- 手机号 -->
        <el-table-column prop="phone" :label="$t('lang.lab_phone')" :sortable="'custom'" width="120px"></el-table-column>
        <!-- 票数 -->
        <el-table-column prop="votes" :label="$t('lang.lab_votes')" :sortable="'custom'">
          <template slot-scope="scope">
            <el-link type="primary" @click="linkVotes(scope.row.competeId,scope.row.id)">{{ scope.row.votes }}</el-link>
          </template>          
        </el-table-column>
        <!-- 人气分 -->
        <el-table-column prop="popularPoint" :label="$t('lang.lab_popularPoint')" :sortable="'custom'">
          <template slot-scope="scope">
            <span v-if="scope.row.popularity === true" class="red">{{ scope.row.popularPoint | valueIsNull}}</span>
            <span v-else>{{ scope.row.popularPoint | valueIsNull}}</span>
          </template>   
        </el-table-column>
        <!-- 专家分 -->
        <el-table-column prop="technicalPoint" :label="$t('lang.lab_technicalPoint')" :sortable="'custom'">
          <template slot-scope="scope">
            <span>{{ scope.row.technicalPoint | valueIsNull}}</span>
          </template> 
        </el-table-column>
        <!-- 收货地址 -->
        <el-table-column prop="address" :label="$t('lang.lab_address')" fixed="right">
          <template slot-scope="scope">
            <el-button @click="onAddress(scope.row)">{{$t('lang.btn_detail')}}</el-button>
          </template>
        </el-table-column>
        <!-- 参赛文件 -->
        <el-table-column prop="hasFile" :label="$t('lang.lab_file')" fixed="right">
          <template slot-scope="scope">
            <template v-if="scope.row.hasFile === 1">
              <el-button @click="onFile(scope.row.competeId,scope.row.id,scope.row.enrollStatus,scope.row.reviewStatus)">{{$t('lang.btn_detail')}}</el-button>
            </template>  
            <template v-else>
              <span >{{$t('lang.lab_valueIsNull') }}</span>
            </template>
          </template>
        </el-table-column>
        <!-- 操作-取消报名 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" width="120px">
          <template slot-scope="scope">
            <template v-if="scope.row.enrollStatus === 1 || scope.row.remark">
              <!-- 备注 -->
              <el-button v-if="scope.row.remark" @click="onRemark(scope.row.remark)">{{$t('lang.btn_notes')}}</el-button>
              <!-- 取消报名 -->
              <el-button v-if="scope.row.enrollStatus === 1" @click="onCancel(scope.row.competeId,scope.row.id)">{{$t('lang.lab_cancelEnroll')}}</el-button>
            </template>  
            <template v-else>
              <span >{{$t('lang.lab_valueIsNull') }}</span>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
    <!-- 收货地址 -->
    <el-dialog 
      :title="isTitle"
      :visible.sync="isShow" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      center
      top="130px"
      width="880px"
      v-if="isShow"
      @close="handleDialogClosed">
      <el-form ref="form" label-width="120px" label-suffix=":">
        <!-- 收件人 -->
        <el-form-item :label="$t('lang.lab_addressee')">
          <span>{{ this.form.name}}</span>
        </el-form-item>
        <!-- 联系方式 -->
        <el-form-item :label="$t('lang.lab_contactInfo')">
          <span>{{ this.form.phone}}</span>
        </el-form-item>
        <!-- 收货地址 -->
        <el-form-item :label="$t('lang.lab_address')">
          <span>{{ this.form.address}}</span>
        </el-form-item>
        <!-- 复制地址 -->
        <el-form-item :label="$t('lang.lab_copyAddress')">
          <el-row>
            <el-col :span="18">
              <input style="display: none"/>
              <el-input id="address" v-model="this.form.copy"></el-input>
            </el-col>
            <el-col :span="6">
              <el-button type="primary" class="margin-l5" @click="onCopy()">{{$t('lang.btn_copyAddress')}}</el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 备注 -->
    <el-dialog 
      :title="isTitleC"
      :visible.sync="isShowC" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      center
      top="130px"
      width="880px"
      v-if="isShowC"
      @close="handleDialogClosedC">
      <el-form ref="form" label-width="100px" label-suffix=":">
        <!-- 备注 -->
        <el-form-item :label="$t('lang.btn_notes')">
          <span>{{ this.cForm.remark}}</span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:playerList
 *@Description:选手列表
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-08-04
 */
import { excelDownload } from '../../config/download.js'

export default {
  name: '',
  components: {},
  data() {
    return {
      competeId: '', // 通过id查找某个赛事的选手列表
      competeName: '', // 赛事名称
      isShow: false, // 收货地址dialog的显示控制
      isTitle: this.$i18n.t('lang.lab_address'), // 收货地址dialog的title
      isShowC: false, // 备注dialog的显示控制
      isTitleC: this.$i18n.t('lang.btn_notes'), // 备注dialog的title
      /* 选手列表变量 */
      multipleSelection: [], // 复选框
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      total: 0, // 数据总数
      genders: this.$i18n.t('lang.Players_gender'), // 性别下拉list
      states: this.$i18n.t('lang.Player_enrollStatus'), // 状态下拉list
      gender: '', // 筛选-性别
      state: '', // 筛选-状态
      name: '', // 筛选-姓名
      certificateNum: '', // 筛选-证件号
      sortName: '', // 升序/降序
      sortFieldName: '', // 排序字段
      tableData: [], // 选手列表数据
      /* 记忆筛选项值 */
      state_bak: '', // 备份-状态
      gender_bak: '', // 备份-性别
      name_bak: '', // 备份-姓名
      certificateNum_bak: '', // 备份-证件号
      /* 数据导出 */
      allData: [], 
      /* 成绩导入 */
      uploadFile: '', // 文件
      fileList: [], // 上传
      /* 收货地址变量 */
      form: {
        name: '',
        phone: '',
        address: '',
        copy: ''
      }, // 详细数据
      /* 选手分组管理(备注)变量 */
      cForm: {
        remark: ''
      }, // 详细数据
    }
  },
  computed: {},
  watch: {},
  methods: {
    // 获取选手列表数据
    getData() {
      this.$get(`/player/onLine/playerList?competeId=${this.competeId}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 查询
    onSearch(flag, isSearch) { 
      if (flag) {
        this.pageNum = 1
      }
      if (isSearch) {
        // 记忆筛选项值
        this.state_bak = this.state
        this.gender_bak = this.gender
        this.name_bak = this.name
        this.certificateNum_bak = this.certificateNum
      } else { 
        // 筛选项正确显示
        this.state = this.state_bak
        this.gender = this.gender_bak
        this.name = this.name_bak
        this.certificateNum = this.certificateNum_bak
      }
      this.$get(`/player/onLine/playerList?competeId=${this.competeId}&playerName=${this.name}&gender=${this.gender}&status=${this.state}&idCard=${this.certificateNum}&sortName=${this.sortName}&sortFieldName=${this.sortFieldName}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )      
    },
    // 重置
    onClear() {
      this.state = ''
      this.gender = ''
      this.name = ''
      this.certificateNum = ''
      this.state_bak = ''
      this.gender_bak = ''
      this.name_bak = ''
      this.certificateNum_bak = ''
      this.sortName = ''
      this.sortFieldName = ''
      this.pageNum = 1
      this.getData()
    },
    // 批量通过
    onPass() {
      console.log('onPass')
      var array = []
      for (let index = 0; index < this.multipleSelection.length; index++) {
        array.push(this.multipleSelection[index].id)
      }
      if (array.length === 0) {
        this.$message.error(this.$i18n.t('lang.warning_selectOnePass'))
        return        
      }
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isPass'), this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$get(`/player/reviewPlayerList?competeId=${this.competeId}&playerIds=${array}&status=2`).then(
            res => {
              loading.close()
              if (res && res.code === 200) {
                // 操作成功的结果
                this.$message.success(res.message)
                // 更新tableData
                this.onSearch(true, false)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )   
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_cancelPass')
          })
        })  
    },
    // 投票详情
    linkVotes(competeId, playerId) {
      console.log('linkVotes', competeId, playerId)
      this.$router.push({ name: 'playerVotes', query: { competeId: competeId, playerId: playerId } })          
    },
    // 收货地址
    onAddress(data) {
      console.log('onAddress', data)
      this.form.name = data.name
      this.form.phone = data.phone
      this.form.address = data.address
      this.form.copy = this.form.name + ',' + this.form.phone + ',' + this.form.address
      this.isShow = true
    },
    // 参赛文件
    onFile(competeId, playerId, enrollStatus, reviewStatus) {
      let examine = false
      if (enrollStatus === 1 && reviewStatus === 1) {
        examine = true
      }
      console.log('onFile', competeId, playerId)
      this.$router.push({ name: 'competeFiles', query: { competeId: competeId, playerId: playerId, examine: examine } })      
    },
    // 操作-备注
    onRemark(data) {
      console.log('onRemark', data)
      this.cForm.remark = data
      this.isShowC = true
    },
    // 操作-取消报名
    onCancel(competeId, playerId) {
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isCancelEnroll'), this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$get(`/my/onLine/closeEnroll?competeId=${competeId}&playerId=${playerId}`).then(
            res => {
              loading.close()
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_successOperation')
                })
                // 更新tableData
                this.onSearch(false, false)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )   
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_cancelOperation')
          })
        })  
    },
    // 点击复制
    onCopy() {
      var content = document.getElementById('address')
      content.select()
      document.execCommand('Copy')
    },
    // 监听关闭'收货地址'dialog
    handleDialogClosed() {
      console.log('handleDialogClosed')
      this.isShow = false
      this.form.name = ''
      this.form.phone = ''
      this.form.address = ''
      this.form.copy = ''
    },
    // 监听关闭'备注'dialog
    handleDialogClosedC() {
      console.log('handleDialogClosed')
      this.isShowC = false
      this.cForm.remark = ''
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false, false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false, false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      console.log('多选', val)
      this.multipleSelection = val
    },
    // 监听表格排序
    changeTableSort(column) {
      console.log('排序', column)
      // 将排序传给后台
      this.sortName = column.order
      this.sortFieldName = column.prop
      this.onSearch(true, false)
    },
    // 获取全部数据
    getAllData() {
      // 筛选项正确显示
      this.state = this.state_bak
      this.gender = this.gender_bak
      this.name = this.name_bak
      this.certificateNum = this.certificateNum_bak
      let loading = this.$loading()
      this.$get(`/player/onLine/playerList?competeId=${this.competeId}&playerName=${this.name}&gender=${this.gender}&status=${this.state}&idCard=${this.certificateNum}&sortName=${this.sortName}&sortFieldName=${this.sortFieldName}`).then(
        res => {
          loading.close()
          if (res && res.code === 200) {
            this.allData = res.data.list
            let newArr = []
            let index = ''
            let gender = ''
            let status = ''
            let type = ''
            if (this.allData.length > 0) {
              for (let i = 0; i < this.allData.length; i++) {
                index = i + 1
                // 判断性别
                gender = this.allData[i].gender
                // if (this.allData[i].gender === 0) {
                //   gender = this.$i18n.t('lang.Players_gender[1].name')
                // } else {
                //   gender = this.$i18n.t('lang.Players_gender[2].name')
                // }
                // 判断状态
                if (this.allData[i].enrollStatus === 0) {
                  status = this.$i18n.t('lang.Player_enrollStatus[1].name')
                } else if (this.allData[i].enrollStatus === 1 && this.allData[i].reviewStatus === 0) {
                  status = this.$i18n.t('lang.Player_enrollStatus[2].name')
                } else if (this.allData[i].enrollStatus === 1 && this.allData[i].reviewStatus === 1) {
                  status = this.$i18n.t('lang.Player_enrollStatus[3].name')
                } else if (this.allData[i].enrollStatus === 1 && this.allData[i].reviewStatus === 2) {
                  status = this.$i18n.t('lang.Player_enrollStatus[4].name')
                } else if (this.allData[i].enrollStatus === 1 && this.allData[i].reviewStatus === 3) {
                  status = this.$i18n.t('lang.Player_enrollStatus[5].name')
                } else {
                  status = ''
                }
                // 判断证件类型
                if (this.allData[i].idType === '0') {
                  type = this.$i18n.t('lang.MeetingRecordDetail_idType[0].name')
                } else if (this.allData[i].idType === '1') {
                  type = this.$i18n.t('lang.MeetingRecordDetail_idType[1].name')
                } else if (this.allData[i].idType === '2') {
                  type = this.$i18n.t('lang.MeetingRecordDetail_idType[2].name')
                } else if (this.allData[i].idType === '3') {
                  type = this.$i18n.t('lang.MeetingRecordDetail_idType[3].name')
                } 
                newArr.push({
                  index: index,
                  ranking: this.allData[i].ranking,
                  competeOrder: this.allData[i].competeOrder,
                  name: this.allData[i].name,
                  gender: gender,
                  age: this.allData[i].age,
                  birthday: this.allData[i].birthday,
                  status: status,
                  idType: type,
                  idCard: this.allData[i].idCard,
                  phone: this.allData[i].phone,
                  votes: this.allData[i].votes,
                  popularPoint: this.allData[i].popularPoint,
                  technicalPoint: this.allData[i].technicalPoint,
                  address: this.allData[i].address,
                })
              }
            }
            // Excel表头
            const tHeader = [
              this.$i18n.t('lang.lab_index'),
              this.$i18n.t('lang.lab_ranking'),
              this.$i18n.t('lang.lab_competeOrder'),
              this.$i18n.t('lang.lab_name'),
              this.$i18n.t('lang.lab_gender'),
              this.$i18n.t('lang.lab_age'),
              this.$i18n.t('lang.lab_birthday'),
              this.$i18n.t('lang.lab_enrollStatus'),
              this.$i18n.t('lang.lab_certificateType'),
              this.$i18n.t('lang.lab_certificateNum'),
              this.$i18n.t('lang.lab_phone'),
              this.$i18n.t('lang.lab_votes'),
              this.$i18n.t('lang.lab_popularPoint'),
              this.$i18n.t('lang.lab_technicalPoint') + this.$i18n.t('lang.lab_technicalPointRule'),
              this.$i18n.t('lang.lab_address'),
            ]
            // 对应table数据的列字段名
            const filterVal = [
              'index',
              'ranking',
              'competeOrder',
              'name',
              'gender',
              'age',
              'birthday',
              'status',
              'idType',
              'idCard',
              'phone',
              'votes',
              'popularPoint',
              'technicalPoint',
              'address',
            ]
            excelDownload(tHeader, filterVal, newArr, this.competeName + this.$i18n.t('lang.lab_playersList'))
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 数据导出
    onExport() {
      if (navigator.onLine) {
        this.$confirm(this.$i18n.t('lang.lab_notModify1') + this.$i18n.t('lang.lab_technicalPoint') + this.$i18n.t('lang.lab_notModify2'), this.$i18n.t('lang.lab_prompt'),
          {
            confirmButtonText: this.$i18n.t('lang.btn_startExport'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            showCancelButton: false,
            type: 'info'
          }
        ).then(() => {
          this.getAllData()        
        })
        .catch(() => {
        })
      } else {
        this.$message.error(this.$i18n.t('lang.warning_network'))
      }      
    },
    // 文件上传数量超过提醒
    outlimit() {
      this.$message.warning(this.$i18n.t('lang.warning_uploadLimit'))
    },
    // 文件移除
    handleRemove(file, fileList) {
      console.log('Remove Success!', file, fileList)
      this.fileList = []
      this.uploadFile.length = 0
    },
    // 文件上传
    handleSuccess(e) {
      console.log('Upload Success!', e)
      this.uploadFile = e.raw
    },
    // 上传文件的断网
    uploadErr() {
      if (!navigator.onLine || window.navigator.onLine === false) {
        const loading = this.$loading()
        setTimeout(() => {
          loading.close()
          this.$message.error(this.$i18n.t('lang.warning_network'))
        }, 500)
      }
    },
    // 成绩导入
    onImport() {
      if (this.uploadFile.length < 1) {
        this.$message.warning(this.$i18n.t('lang.lab_pleaseSeletcDoc'))
      } else {
        let formData = new FormData()
        formData.append('competeId', this.competeId)
        formData.append('files', this.uploadFile)
        let loading = this.$loading()
        this.$postFormData(`/player/onLine/importResult`, formData).then(
          res => {
            loading.close()
            if (res && res.code === 200) {
              this.$message.success(this.$i18n.t('lang.lab_uploadSuccess'))
              this.onClear()
              this.fileList = []
            } else {
              this.$confirm(res.message, this.$i18n.t('lang.lab_prompt'),
                {
                  confirmButtonText: this.$i18n.t('lang.btn_confirm'),
                  cancelButtonText: this.$i18n.t('lang.btn_cancel'),
                  showCancelButton: false,
                  type: 'warning'
                }
              ).then(() => {           
                })
                .catch(() => {
                })  
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      }
    },
    // 返回
    goBack() {
      window.history.go(-1)
    }
  },
  created() {
    this.competeId = this.$route.query.competeId
    this.competeName = this.$route.query.competeName
    if (this.competeId !== '') {
      this.getData()
    }
  },
  mounted() {}
}
</script>

<style lang='scss'>
.playerList{
  .margin-l5{
    margin-left: 5px;
  }
  .red{
    color: red;
  }
}
</style>
